import AspectRatio from "../../../AspectRatio";

const VimeoPlayer = ({ videoUrl }) => {
  // Verificar si la URL es de Vimeo
  const isVimeoUrl = (url) => {
    return url?.includes("vimeo.com");
  };

  // Extraer el ID del video de la URL
  const getVideoId = (url) => {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:$|\/|\?)/;
    const match = url.match(regex);
    return match ? match[2] : null;
  };

  // Renderizar el reproductor de Vimeo si es una URL válida de Vimeo
  if (isVimeoUrl(videoUrl)) {
    const videoId = getVideoId(videoUrl);
    return (
      <AspectRatio
        ratio="16/9"
        maxWidth={940}
        key={`attached-file-${videoUrl}`}
      >
        <iframe
          src={`https://player.vimeo.com/video/${videoId}`}
          width="640"
          height="360"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Vimeo video player"
          style={{ border: 0, maxWidth: "100%" }}
        />
      </AspectRatio>
    );
  } else {
    return <p>No es una URL válida de Vimeo</p>;
  }
};

export default VimeoPlayer;
